import React from 'react';
import styled from 'styled-components';

// import startCase from 'lodash/startCase';
import moment from 'moment';
import Alert from 'antd/lib/alert';
import {
  CheckCircleOutlined,
  CloseCircleOutlined,
} from '@ant-design/icons';
import { Link } from 'react-router-dom';

import Popover from '../../components/Popover';
// import Query from 'hive-admin/src/components/Query';

import getRoleBasedPath from '../../helpers/getRoleBasedPath';

import {
  StoreLink,
  AmountLink,
  OrderStatusLink,
  DateLink,
} from '../../components/Links';

import { renderCurrency } from '../../components/SystemCountry';

import Types from '../../modules/types';

import applePayMarkSrc from '../../assets/apple-pay-mark.svg';

// const PAYTABS_PAYMENT_STATUS_LABELS = (
//   Object.keys(Types.PAYTABS_PAYMENT_STATUS)
//   .reduce(
//     (agr, key) => {
//       agr[Types.PAYTABS_PAYMENT_STATUS[key]] = startCase(key.toLowerCase());
//       return agr;
//     },
//     {},
//   )
// );

function isSellerOnResellerOrder(order, viewer) {
  return (
    order
    && order.store
    && order.store.type === 'RESELLER'
    && viewer
    && viewer.role === 'SELLER'
    && viewer.store !== order.store._id
  );
}

function getRealCost(order, viewer) {
  return order.costs.find(cost => cost.store === viewer.store) || order.cost;
}

const SpanNoWrap = styled.span`
  white-space: nowrap;
  display: inline-block;
`;

const ProductsSummaryTrigger = styled.span`
  display: inline-flex;
  width: 100%;
  height: 100%;
  align-items: center;
`;

const ApplePayMark = styled.img`
  width: 30px;
  margin-left: 8px;
  transform: translateY(-1px);
  opacity: 0.6;
`;

// const PaytabsReferenceSpan = styled.span`
//   opacity: 0.5;
//   font-size: 80%;
//   vertical-align: middle;
//   > span {
//     cursor: pointer;
//   }
// `;

export const columnIdAdmin = {
  path: '_id',
  title: 'ID',
  link: '/orders/:_id',
  // eslint-disable-next-line arrow-body-style
  render: (record, _index, _props) => {
    return (
      <SpanNoWrap>
        <>
          <Link to={`/orders/${record._id}`}>
            {`${record._id}`}
          </Link>
          {/* {
            record.draftedFrom
            ? (
                <>
                  &nbsp;
                  <span>
                    from
                  </span>
                  &nbsp;
                  <span>
                    <Link to={`/orders/${record.draftedFrom}`}>
                      {`${record.draftedFrom}`}
                    </Link>
                  </span>
                </>
              )
            : null
          } */}
        </>
        {/* {
          record.payment && record.payment.paytabsReference
          ? (
              <>
                <PaytabsReferenceSpan>
                  {' / '}
                </PaytabsReferenceSpan>
                <PaytabsReferenceSpan>
                  <Popover
                    trigger="click"
                    title={`PayTabs: ${record.payment.paytabsReference}`}
                    content={(
                      <Query
                        client={props.client}
                        url={`/orders/${record._id}/dev/paytabs/get-payment`}
                      >
                        {({ data, loading }) => (
                          <pre>
                            <code style={{ fontSize: '80%' }}>
                              {
                                data && data.data && data.data.response_code
                                ? `Status: ${(
                                    PAYTABS_PAYMENT_STATUS_LABELS[
                                      data.data.response_code
                                    ] || 'N/A'
                                  )}\n`
                                : ''
                              }
                              {
                                loading
                                ? 'Loading Response...'
                                : data && data.data
                                ? JSON.stringify(data.data, null, '  ')
                                : 'Error'
                              }
                            </code>
                          </pre>
                        )}
                      </Query>
                    )}
                  >
                    PT
                  </Popover>
                </PaytabsReferenceSpan>
              </>
            )
          : null
        } */}
      </SpanNoWrap>
    );
  },
};
export const columnIdSellerMerchant = {
  path: '_id',
  link: '/store/orders/:_id',
  render: (record, column, props) => {
    const link = (
      <Link to={`/store/orders/${record._id}`}>
        {record._id}
      </Link>
    );
    const sellerOnReseller = isSellerOnResellerOrder(record, props.viewer);
    return (
      <SpanNoWrap>
        <>
          {
            sellerOnReseller
              ? (
                <>
                  {link}
                  &nbsp;
                  via
                  &nbsp;
                  {record.store.name}
                </>
              )
              : (
                <>
                  {link}
                </>
              )
          }
          {/* {
            !sellerOnReseller && record.draftedFrom
            ? (
                <>
                  &nbsp;
                  /
                  &nbsp;
                  <SpanNoWrap>
                    from POS
                    &nbsp;
                    <Link to={`/store/orders/${record.draftedFrom}`}>
                      {`${record.draftedFrom} `}
                    </Link>
                  </SpanNoWrap>
                </>
              )
            : null
          } */}
        </>
      </SpanNoWrap>
    );
  },
};
export const columnIdSellerReseller = {
  path: '_id',
  link: '/store/reseller/orders/:_id',
  // eslint-disable-next-line no-unused-vars
  render: (record, column, props) => {
    const link = (
      <Link to={`/store/reseller/orders/${record._id}`}>
        {record._id}
      </Link>
    );
    return (
      <SpanNoWrap>
        <>
          {link}
          {
            record.draftedFrom
              ? (
                <>
                  &nbsp;
                  /
                  &nbsp;
                  <SpanNoWrap>
                    from POS
                    &nbsp;
                    <Link to={`/store/reseller/orders/${record.draftedFrom}`}>
                      {`${record.draftedFrom} `}
                    </Link>
                  </SpanNoWrap>
                </>
              )
              : null
          }
        </>
      </SpanNoWrap>
    );
  },
};
export const columnIdSellerReferral = {
  path: '_id',
  link: '/store/partners/orders/:_id',
};

export const columnStatus = {
  path: 'Order Status',
  render: (record, column, props) => (
    <span>
      <OrderStatusLink
        location={props.location}
        subject={record}
        viewer={props.viewer}
        pathname={getRoleBasedPath(props, '/orders')}
      />
      {
        record.restored || record.statusAdjusted
          ? (
            <span style={{ opacity: 0.6, textTransform: 'uppercase' }}>
              &nbsp;
              {
                record.restored
                  ? '(restored)'
                  : '(status adjusted)'
              }
            </span>
          )
          : null
      }
      {
        record?.status === 'INVALID_PAYMENT'
          && record?.payment?.method === 'CARD'
          && record?.payment?.provider === 'CHECKOUT'
          && !record?.payment?.checkoutId
          ? (
            <span style={{ opacity: 0.6, fontSize: '13px' }}>
              &nbsp;
              (Timed Out)
            </span>
          )
          : (
            <>
              {/* eslint-disable-next-line max-len */}
              <span style={{ opacity: 0.6, whiteSpace: 'nowrap', fontSize: '13px' }}>
                &nbsp;
                {/* eslint-disable-next-line max-len */}
                {record.message && `(${String(record.message).split(': ')[1] || record?.message?.trim()})`}
              </span>
            </>
          )
      }
    </span>
  ),
};
export const columnPaymentStatus = {
  path: 'Payment Status',
  render: (record, column, props) => (
    <div style={{ display: 'flex', justifyContent: 'center' }}>
      <span style={{ textAlign: 'center' }}>
        {(() => {
           if (record?.payment?.method === 'COD_CASH') {
            return (
              <Alert
                message="Cash On Delivery"
                type="info"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          // eslint-disable-next-line max-len
          if (record?.payment?.method === 'TABBY' && record?.payment?.captured) {
            return (
              <Alert
                message="Captured"
                type="success"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
           // eslint-disable-next-line max-len
           if (record?.payment?.method === 'TABBY' && record?.payment?.authorized) {
            return (
              <Alert
                message="Authorized"
                type="info"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
           if (record?.payment?.method === 'COD_CARD') {
            return (
              <Alert
                message="Card On Delivery"
                type="info"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          if (record?.payment?.refunded) {
            return (
              <Alert
                message="Refunded"
                type="error"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          if (record?.payment?.captured) {
            return (
              <Alert
                message="Captured"
                type="success"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          if (record?.payment?.authorized) {
            return (
              <Alert
                message="Authorized"
                type="info"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          if (record.payment?.voided) {
            return (
              <Alert
                message="Voided"
                type="warning"
                // eslint-disable-next-line max-len
                style={{ display: 'inline-block', padding: '4px 8px', fontSize: '13px' }}
              />
            );
          }
          return '';
        })()}
      </span>
    </div>
  ),
};

export const columnStore = {
  path: 'store',
  title: 'Store',
  render: (record, column, props) => (
    record.store
      ? (
        <StoreLink
          location={props.location}
          subject={record.store}
          pathname={getRoleBasedPath(props, '/orders')}
        />
      )
      : 'N/A'
  ),
};

export const columnCustomer = {
  path: 'shippingDetails.email',
  title: 'Customer',
  render: (record) => (
    record?.shippingDetails?.name
      ? (
        <span>
          {record?.shippingDetails?.name}
          {
            record?.shippingDetails?.email
              ? (
                <span style={{ opacity: 0.6 }}>
                  &nbsp;
                  /
                  &nbsp;
                  {record?.shippingDetails?.email}
                </span>
              )
              : null
          }
        </span>
      )
      : ''
  ),
};

export const columnShippingMethod = {
  path: 'shipping.method',
  title: 'Shipping',
  render: (record, column, props) => (
    isSellerOnResellerOrder(record, props.viewer)
      ? 'N/A'
      : record.shipping?.method
        ? (
          <span>
            {
              Types.SHIPPING_METHOD_LABELS_MAP[record.shipping.method]
            }
            {
              record.shipping?.company?.name
                ? (
                  <>
                    {' / '}
                    <Link
                      to={`/shipping/companies/${record.shipping.company._id}`}
                    >
                      {record.shipping?.company?.name}
                    </Link>
                  </>
                )
                : ''
            }
          </span>
        )
        : 'N/A'
  ),
};

export const columnAirwayBillUploaded = {
  path: 'airwayBill',
  title: 'AWB',
  align: 'center',
  render: record => (
    record.airwayBill?._id || record.airwayBill?.src
      ? (
        <CheckCircleOutlined
          title="Uploaded"
          style={{ color: '#52c41a', fontSize: 18 }}
        />
      )
      : (
        <CloseCircleOutlined
          title="Not uploaded yet"
          style={{ color: '#bfbfbf', fontSize: 18 }}
        />
      )
  ),
};

export const columnCostCharged = {
  path: 'cost.charged',
  title: 'Charged',
  align: 'right',
  sort: 'amount',
  render: (record, column, props) => (
    isSellerOnResellerOrder(record, props.viewer)
      ? renderCurrency({
        prefix: `${Types.decimalize(getRealCost(
          record,
          props.viewer,
        ).charged || 0)} `,
      })
      : (
        <AmountLink
          location={props.location}
          subject={record}
          valuePath="cost.charged"
          pathname={getRoleBasedPath(props, '/orders')}
        />
      )
  ),
};

export const columnCostReferralRevenue = {
  path: 'cost.referralRevenue',
  title: 'Revenue',
  align: 'right',
  render: (record, column, props) => (
    <AmountLink
      location={props.location}
      subject={record}
      valuePath="cost.referralRevenue"
      pathname={getRoleBasedPath(props, '/orders')}
    />
  ),
};

export const columnCostResellerRevenue = {
  path: 'cost.resellerRevenue',
  title: 'Revenue',
  align: 'right',
  render: (record, column, props) => (
    <AmountLink
      location={props.location}
      subject={record}
      valuePath="cost.resellerRevenue"
      pathname={getRoleBasedPath(props, '/orders')}
    />
  ),
};

export const columnCostDelivery = {
  path: 'cost.shipping',
  title: 'Shipping Cost',
  align: 'right',
  sort: 'shipping',
  render: (record, column, props) => (
    isSellerOnResellerOrder(record, props.viewer)
      ? 'N/A'
      : renderCurrency({
        prefix: `${Types.decimalize(record.cost.shipping || 0)} `,
      })
  ),
};

export const columnPaymentType = {
  path: 'payment.method',
  title: 'Payment Method',
  align: 'right',
  render: (record, column, props) => (
    isSellerOnResellerOrder(record, props.viewer)
      ? 'N/A'
      : (record.payment && record.payment.method)
        ? (
          <>
            {Types.PAYMENT_METHOD_LABELS_MAP[record.payment.method]}
            {
              record.payment.submethod === 'APPLE_PAY'
                ? (
                  <ApplePayMark
                    alt="Apple Pay Mark"
                    src={applePayMarkSrc}
                  />
                )
                : null
            }
            {
              // eslint-disable-next-line max-len
              props.viewer?.role === 'ADMIN' && record?.payment?.method === 'CARD'
                ? (
                  <>
                    <span style={{ marginLeft: '10px' }}>
                      |
                    </span>
                    <span style={{ marginLeft: '8px' }}>
                      {`${Types.PAYMENT_CARD_PROVIDER_MAP[
                        record.payment.provider
                      ]?.label
                        ? Types.PAYMENT_CARD_PROVIDER_MAP[
                          record.payment.provider
                        ]?.label
                        : record.payment.provider
                        }`}
                    </span>
                  </>
                )
                : null
            }
          </>
        )
        : 'N/A'
  ),
};

export const columnCreatedAt = {
  path: 'createdAt',
  title: 'Created At',
  sort: 'created',
  render: (record, column, props) => (
    <DateLink
      date={record.createdAt}
      location={props.location}
      pathname={getRoleBasedPath(props, '/orders')}
    >
      {moment(record.createdAt).format(
        'dddd, MMMM Do YYYY [at] h:mm a'
      )}
    </DateLink>
  ),
};

export const columnApprovedAt = {
  path: 'approvedAt',
  title: 'Approved At',
  sort: 'approved',
  render: (record, column, props) => (
    record.approvedAt
      ? (
        <DateLink
          date={record.approvedAt}
          location={props.location}
          pathname={getRoleBasedPath(props, '/orders')}
        >
          {moment(record.approvedAt).format(
            'dddd, MMMM Do YYYY [at] h:mm a'
          )}
        </DateLink>
      )
      : '-'
  ),
};

export const columnShippedAt = {
  path: 'shippedAt',
  title: 'Shipped At',
  sort: 'shipped',
  render: (record, column, props) => (
    record.shippedAt
      ? (
        <DateLink
          date={record.shippedAt}
          location={props.location}
          pathname={getRoleBasedPath(props, '/orders')}
        >
          {moment(record.shippedAt).format(
            'dddd, MMMM Do YYYY [at] h:mm a'
          )}
        </DateLink>
      )
      : '-'
  ),
};

export const columnCompletedAt = {
  path: 'completedAt',
  title: 'Completed At',
  sort: 'completed',
  render: (record, column, props) => (
    record.completedAt
      ? (
        <DateLink
          date={record.completedAt}
          location={props.location}
          pathname={getRoleBasedPath(props, '/orders')}
        >
          {moment(record.completedAt).format(
            'dddd, MMMM Do YYYY [at] h:mm a'
          )}
        </DateLink>
      )
      : '-'
  ),
};

export const columnProductsSummary = {
  path: 'items',
  title: 'Products',
  render: (record) => {
    if (!Array.isArray(record.items) || record.items.length === 0) {
      return '-';
    }
    const normalizedItems = record.items
      .map((item) => {
        if (!item) {
          return null;
        }
        const name = item.name || item.productName || 'Product';
        const variant = item.variant?.name;
        const quantity = Number.isFinite(item.quantity) ? item.quantity : 0;
        if (!name && !variant && !Number.isFinite(quantity)) {
          return null;
        }
        return {
          key: item._id || item.sku || `${name}-${variant || ''}`,
          name,
          variant,
          quantity,
        };
      })
      .filter(Boolean);
    if (normalizedItems.length === 0) {
      return '-';
    }
    const totalQuantity = normalizedItems.reduce(
      (sum, item) => sum + (Number.isFinite(item.quantity) ? item.quantity : 0),
      0,
    );
    return (
      <Popover
        content={(
          <div style={{ maxWidth: '260px' }}>
            {
              normalizedItems.map((item) => (
                <div key={`${item.key}`}>
                  {item.name}
                  {item.variant ? ` (${item.variant})` : ''}
                  {' x'}
                  {item.quantity}
                </div>
              ))
            }
          </div>
        )}
        placement="top"
      >
        <ProductsSummaryTrigger>
          {totalQuantity}
        </ProductsSummaryTrigger>
      </Popover>
    );
  },
};

export const columnComment = {
  path: 'comment',
  title: 'Comment',
  render: (record) => {
    if (!record.comment) {
      return null;
    }
    return (
      <Popover
        content={(
          <div style={{ maxWidth: '300px', whiteSpace: 'pre-wrap' }}>
            {record.comment}
          </div>
        )}
        placement="top"
      >
        <span style={{ cursor: 'pointer', textDecoration: 'underline' }}>
          Comment
        </span>
      </Popover>
    );
  },
};

export const ADMIN = [
  columnIdAdmin,
  columnStatus,
  columnPaymentStatus,
  columnProductsSummary,
  columnComment,
  columnStore,
  columnCustomer,
  columnShippingMethod,
  columnAirwayBillUploaded,
  columnCostCharged,
  columnCostDelivery,
  columnPaymentType,
  columnCreatedAt,
  columnApprovedAt,
  columnShippedAt,
  columnCompletedAt,
];

export const ADMIN_APPROVAL = [
  columnIdAdmin,
  columnStore,
  columnCustomer,
  columnShippingMethod,
  columnCostCharged,
  columnCostDelivery,
  columnPaymentType,
  columnCreatedAt,
];

export const SELLER_MERCHANT = [
  columnIdSellerMerchant,
  columnStatus,
  columnPaymentStatus,
  columnProductsSummary,
  columnComment,
  columnCustomer,
  columnShippingMethod,
  columnAirwayBillUploaded,
  columnCostCharged,
  columnCostDelivery,
  columnPaymentType,
  columnCreatedAt,
  columnApprovedAt,
  columnShippedAt,
  columnCompletedAt,
];

export const SELLER_REFERRAL = [
  columnIdSellerReferral,
  columnStatus,
  columnPaymentStatus,
  columnCostCharged,
  columnCostReferralRevenue,
  columnCreatedAt,
];

export const SELLER_RESELLER = [
  columnIdSellerReseller,
  columnStatus,
  columnPaymentStatus,
  columnCostCharged,
  columnCostResellerRevenue,
  columnCreatedAt,
];

export const SELLER_MERCHANT_APPROVAL = [
  columnIdSellerMerchant,
  columnShippingMethod,
  columnCostCharged,
  columnCostDelivery,
  columnPaymentType,
  columnCreatedAt,
];
